import { render } from "./ArgonPagination.vue?vue&type=template&id=54b4e9ae"
import script from "./ArgonPagination.vue?vue&type=script&lang=js"
export * from "./ArgonPagination.vue?vue&type=script&lang=js"

import exportComponent from "/home/leandro/trabalho-timo/kuhlenbier-web-frontend-partner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__